<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" class="mr15" v-if="getPermission('ymsDistributorLabel_inset')"
        @click="$refs['createLabel'].initLabelData('add')">{{ $t('key1003206') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--创建、编辑标签-->
    <createLabelModal ref="createLabel" @updateData="getList()"></createLabelModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import createLabelModal from "@/views/yms/components/customerManage/createLabelModal.vue";
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

export default {
  name: "customerLabel",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003218'),
          key: 'labelName',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003219'),
          key: 'merchantNumber',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          align: 'left',
          minWidth: 170,
          key: 'createdTime',
          render(h, params) {
            let createdTime = params.row.createdTime;
            return h('span', v.$uDate.dealTime(createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003220'),
          key: 'remark',
          width: 300,
          align: 'left',
          render(h, params) {
            let remark = params.row.remark;
            return v.checkContentOverflow(h, remark, 300, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 220,
          align: 'left',
          render: (h, params) => {
            let ymsLabelId = params.row.ymsLabelId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsDistributorLabel_update'),
                    clickFn: () => {
                      v.$refs['createLabel'].initLabelData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsDistributorLabel_delete'),
                    clickFn: () => {
                      v.deleteLabelBtn(ymsLabelId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getList();
      })();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      if (v.getPermission('ymsDistributorLabel_query')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsDistributorLabel_query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            v.tableData = data;
            v.updateTableDom('tableDom');
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 删除标签
    deleteLabelBtn(ymsLabelId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003221'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003222'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001444'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsDistributorLabel + ymsLabelId, null, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              v.getList();
            }
          });
        },
        onCancel: () => {
        }
      });
      // 动态修改确定按钮的状态
      v.$nextTick(() => {
        const modalEl = document.querySelector('.ivu-modal-confirm');
        const okBtn = modalEl.querySelector('.ivu-btn-primary');
        okBtn.classList.remove('ivu-btn-primary');
        okBtn.classList.add('ivu-btn-error');
      });
    }
  },
  components: {
    createLabelModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-modal-confirm-footer {
  display: none;
}
</style>